import { Avatar } from '../state/models';

// Get avatar image from pair combinations like beard, hair, eyes...

export interface IPair {
  name: string;
  value: string;
}

export function getPairedImage(avatar: Avatar, pair1: IPair, pair2: IPair) {
  return avatar.previewImages.find((preview: any) => {
    if (preview.genderId === 1) {
      return preview[pair1.name] === pair1.value && preview[pair2.name] === pair2.value && preview.genderId === 1;
    }

    return (
      preview[pair1.name] === pair1.value && preview[pair2.name] === pair2.value && preview.genderId === avatar.genderId
    );
  });
}
